import styled from 'styled-components';

export const TagWrapper = styled.div`
	display: flex;
	justify-content: start;
	align-items: center;
	padding: 0.2rem 0rem;
	overflow-x: auto;
`;
